import React from 'react';

const FillPage = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-6">
      <h1 className="text-4xl md:text-3xl lg:text-2xl font-bold mb-4">Applications Closed</h1>
      <p className="text-lg md:text-md lg:text-sm mb-4">
        Cohort 2 application is now complete. Please stay tuned to our Facebook page for upcoming events and information regarding Cohort 3.
      </p>
      <h2 className="text-3xl md:text-2xl lg:text-xl font-bold">Thank you!</h2>
      <a target="_blank" href="https://www.facebook.com/DOSTPUPPYLONTBI" 
          className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">
        Visit Facebook Page
      </a>
    </div>
  );
};

export default FillPage;
